import PropTypes from "prop-types";
import React, { PureComponent, useState } from "react";
import theme from "styles/theme";
import { themeOptions } from "styles/theme";
import NoSwatch from "material-ui/svg-icons/image/texture";
import { getBaseSwatchStyles } from "helpers/swatch-utils";
import { Tooltip as MUITooltip } from "components/tooltip";
import classNames from "classnames";
import { DATATEST } from "constants/integration";
import { toDataTest } from "helpers/test";

const styles = {
    swatchContainer: {
        display: "inline-block",
        border: "2px solid transparent",
        position: "relative",
        height: "32px",
        width: "32px !important",
        borderRadius: "4px",
        marginRight: "0px",
    },
    swatchContainerSelected: {
        border: `2px solid ${themeOptions.palette.accent1Color}`,
    },
    swatch: {
        display: "block",
        position: "absolute",
        top: "2px",
        left: "2px",
        height: "24px",
        width: "24px",
        borderRadius: "4px",
    },
    noSwatch: {
        display: "block",
        position: "absolute",
        top: "2px",
        left: "2px",
        height: "24px",
        width: "24px",
        fill: themeOptions.palette.lightGrey,
    },
    grapesJsTooltipWrapper: {
        position: "relative",
        display: "inline-block",
    },
    grapesJsTooltip: {
        position: "absolute",
        top: "100%",
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "#707070",
        color: "#ffffff",
        padding: "3px 5px",
        borderRadius: "5px",
        zIndex: 1,
        fontSize: "12px",
        fontFamily: themeOptions.palette.fontFamily,
    },
};

class ColorSwatch extends PureComponent {
    static propTypes = {
        item: PropTypes.object.isRequired,
        swatch: PropTypes.object,
        selected: PropTypes.bool,
        isGrapesJs: PropTypes.bool,
        onClick: PropTypes.func,
        style: PropTypes.object,
        swatchStyle: PropTypes.object,
        noSwatchStyle: PropTypes.object,
        tooltip: PropTypes.string,
    };

    static defaultProps = {
        selected: false,
        showTooltip: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            isTooltipShown: false,
        };
    }

    handleTouchTap = (e) => {
        const { onClick, item } = this.props;
        if (onClick) {
            e.preventDefault();
            e.stopPropagation();
            onClick(e, item);
        }
    };

    render() {
        const { swatch, selected, style, swatchStyle, noSwatchStyle, tooltip, isGrapesJs } = this.props;
        const inlineSwatchStyle = getBaseSwatchStyles(swatch);

        return (
            <EncapsulatedTooltip isGrapesJs={isGrapesJs} tooltip={tooltip}>
                <div
                    data-test={DATATEST.GALLERY.COLOR_CHIP}
                    data-title={toDataTest(tooltip)}
                    onClick={this.handleTouchTap}
                    className={classNames("swatchContainer", { selected })}
                    style={Object.assign({}, styles.swatchContainer, style, selected && styles.swatchContainerSelected)}
                >
                    {inlineSwatchStyle ? (
                        <div
                            className="swatch"
                            style={Object.assign({}, styles.swatch, swatchStyle, inlineSwatchStyle)}
                        />
                    ) : (
                        <NoSwatch className="noSwatch" style={Object.assign({}, styles.noSwatch, noSwatchStyle)} />
                    )}
                </div>
            </EncapsulatedTooltip>
        );
    }
}

const EncapsulatedTooltip = ({ children, isGrapesJs, tooltip }) =>
    isGrapesJs ? (
        <TooltipForGrapesJs text={tooltip}>{children}</TooltipForGrapesJs>
    ) : (
        <MUITooltip open={!tooltip ? false : undefined} title={tooltip || ""} placement="top">
            {children}
        </MUITooltip>
    );

const TooltipForGrapesJs = ({ children, text }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div
            style={Object.assign({}, styles.grapesJsTooltipWrapper)}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
        >
            {children}
            {showTooltip && text && <div style={Object.assign({}, styles.grapesJsTooltip)}>{text}</div>}
        </div>
    );
};

export default ColorSwatch;
